import $ from 'jquery';
import 'slick-carousel';
import 'jquery-mousewheel';
import 'malihu-custom-scrollbar-plugin';

var slider = (function(){
	$('.slider').slick({
		infinite: false,
		rows: 0,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		appendDots: '.slider-pagination ',
		arrows: false,
		fade: true,
		speed: 1000,
		cssEase: 'linear'
	});
})();

$(window).on('load', function() {
	$('.members-slider').slick({
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		dots: false,
		arrows: true,
		prevArrow: '<span class="slick-prev"></span>',
		nextArrow: '<span class="slick-next"></span>',
		responsive: [
			{
			  breakpoint: 415,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			  }
			}
		]
	});
});

var cookies = (function() {
	$(".cookies-dialog__content").mCustomScrollbar({
	   mouseWheelPixels: 170,
	   autoDraggerLength:false
    });

    $(document).ready(function() {
        $('.cookies').click( function() {
            $(".cookies-dialog").animate({ left: 0 });
        });

        $('.cookies-dialog .close').on('click', function() {
            $(".cookies-dialog").animate({ left: (-$('.cookies-dialog').outerWidth() - 30) });
        });
    });
})();

var scrollHead = (function(){
	$( document ).ready(function() {
		var header = $('header');
		var toggle = $('.toggle');
		$(window).scroll(function() {
			var scrollamount = $(window).scrollTop();

			if ( scrollamount >= 100 && !toggle.is(".active") ) {
				header.addClass("header--bg");
			} else {
				header.removeClass("header--bg");
		  	}
		});
	});
})();

var header = (function() {
	$(".toggle--menu").click(function() {
	 	$(this).toggleClass("active");
		$(".menu").toggleClass("active");
		$("#overlay").toggleClass("active");
	});

	$("li.has-children span").click(function() {
		$(this).parent().toggleClass("open");
		$(this).next('ul').slideToggle('fast', function (e) {

			if ($(this).parent().offset().top + $(this).parent().height() > window.innerHeight) {
				var position = $(this).parent().position().top + $(".menu__main").scrollTop() - $(".international-mobile").innerHeight() - $(".toggle--menu.active").innerHeight();
				$(".menu__main").animate({ scrollTop:position });
			}
		});
	});

	$(".toggle--login").click(function() {
		$(this).toggleClass("active");
	 	$(".login-form").toggleClass("active");
		$("#overlay").toggleClass("active");
	});

	$(".toggle--search").click(function() {
		$(this).toggleClass("active");
		$("#overlay").toggleClass("active");
	 	$(".search-form").toggleClass("active");
		$(".toggle--login").toggleClass("inactive");
		$(".toggle--menu").toggleClass("inactive");
		$(".international").toggleClass("inactive");
	});
})();

$("#overlay").click(function() {
	$(this).toggleClass("active");
	$("header div").removeClass("active");
	$("header nav").removeClass("active");
	$("header div").removeClass("inactive");
	$(".logo--white").removeClass("active");
	$(".logo").addClass("active");
});

$(".toggle").click(function() {
	$(".logo--white").toggleClass("active");
	$(".logo").toggleClass("active");
});

$(".toggle--menu").click(function() {
	$("header").removeClass("header--bg");
});



// WEBPACK FOOTER //
// ./src/index.js